// ############################ Imported from Old UI ###########################

import { IDropdownOptionForSelect } from '../components/dropdown/Dropdown';

export function isAddressValid(address: string) {
  if (/\b(P\.O\. Box|PO Box|PO. Box|Post Office Box|p.o box|post office)\b/i.test(address.trim())) {
    return false;
  }
  return true;
}

// eslint-disable-next-line max-len
export function isStateValid(state: string, allowedStateList: Array<IDropdownOptionForSelect<string>>) {
  // will return if value in array
  for (const item of allowedStateList) {
    if (item.value === state) {
      return true;
    }
  }
  return false;
}
